<template>
  <div
    v-if="List.name !== '' && !liveMode"
    class="breadCrumbContainer paddingNormal"
  >
    <a
      :href="List.url"
      v-html="List.name"
    />
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: [
    'item_id'
  ],
  data () {
    return {
    }
  },
  computed: {
    List: function () {
      let crumb = {
        name: document.getElementById('breadcrumb_list').innerHTML,
        url: document.getElementById('breadcrumb_list').href
      }
      if (this.getUrlParameter('ref').length > 0) {
        crumb = JSON.parse(this.getUrlParameter('ref'))
      }
      return crumb
    },
    liveMode: function () {
      return this.$store.getters.liveMode
    }
  },
  methods: {
    getUrlParameter: function (name) {
       
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
      let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      let results = regex.exec(location.search)
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }
  }
}
</script>

<style scoped>
</style>
